import { FC } from "react";
import styled from "styled-components";

import { ReactComponent as Logo } from "@/assets/icons/logo.svg";
import { ReactComponent as Box } from "@/assets/icons/ic-box.svg";
import Text from "@/components/Text";

const Inner = styled.div`
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
`;

const Header = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  text-align: center;
  padding: 24px 15px;
  border-bottom: 1px solid ${({ theme }) => theme.colors.lightGray};
`;

const StyledLogo = styled(Logo)`
  height: 24px;
  width: auto;
`;

const Heading = styled(Text)`
  margin: 24px 0 12px;
`;

const Description = styled(Text)`
  width: 253px;
  max-width: 100%;
`;

const MobileWarning: FC = () => {
  return (
    <>
      <Header>
        <StyledLogo />
      </Header>
      <Inner>
        <Box />
        <Heading $type="heading1" as="h1">
          Oh, sorry...
        </Heading>
        <Description $color="gray">
          Currently Backbone can be reached only in desktop version.
        </Description>
      </Inner>
    </>
  );
};

export default MobileWarning;
